module.exports = __webpack_public_path__ + "posture/static/img/pelvis_lean_right.492b5e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/abnormal/pelvis_lean_right.png
// module id = 9izx
// module chunks = 1